import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import styles from './Spinner.scss';

export const POINTS = ['%', 'px', 'pt', 'em'];
export const COLORS = ['black', 'white', 'gray'];

Spinner.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    color: PropTypes.oneOf(COLORS),
    duration: PropTypes.number,
};

Spinner.defaultProps = {
    size: 40,
    duration: 0.8,
    color: 'black',
};

export default function Spinner({ className, borderWidth, size, duration, color, ...rest }) {
    const style = useMemo(() => {
        const normalized = normalizeSize(size);
        const normalizedBorderWidth = normalizeSize(borderWidth || Math.round(+normalized * 0.05));

        return {
            width: normalized,
            height: normalized,
            borderWidth: normalizedBorderWidth,
            animationDuration: `${duration}s`,
            WebkitAnimationDuration: `${duration}s`,
            MozAnimationDuration: `${duration}s`,
        };
    }, [size, duration, borderWidth]);

    return (
        <div className={cn(styles.root, className)}>
            <div className={cn(styles.spinner, styles[color])} style={style} {...rest} />
        </div>
    );
}

export function normalizeSize(size, def = 'px') {
    if (!size) return;

    const str = String(size);
    const withPoints = POINTS.find((points) => str.indexOf(points) > 0);

    return withPoints ? size : `${size}${def}`;
}
